import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-180d5f59")

_pushScopeId("data-v-180d5f59")
const _hoisted_1 = { class: "mt-4 mx-4" }
const _hoisted_2 = { class: "mx-4 lg:mx-12 flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RedirectLabelList = _resolveComponent("RedirectLabelList")
  const _component_DefaultSpinner = _resolveComponent("DefaultSpinner")
  const _component_DefaultBoostpackCard = _resolveComponent("DefaultBoostpackCard")
  const _component_default_media_net_ad = _resolveComponent("default-media-net-ad")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_RedirectLabelList, {
        "label-list": _ctx.categoryListForLabel,
        "selected-label-color": "red",
        "label-color": "indigo",
        "active-labels": _ctx.boostSelectedCategories,
        onDeleteLabel: _ctx.updateAndRedirect,
        onSelectLabel: _ctx.updateAndRedirect
      }, null, 8, ["label-list", "active-labels", "onDeleteLabel", "onSelectLabel"])
    ]),
    _createVNode(_component_DefaultSpinner, {
      id: "feedSpinner",
      "show-spinner": _ctx.isBoostpackFeedLoading(),
      "show-spinner-alternative-text": false,
      "data-aos": "zoom-in-up",
      "data-aos-anchor": "feedSpinner"
    }, null, 8, ["show-spinner"]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.boostpacks, (boostpack) => {
        return (_openBlock(), _createBlock(_component_DefaultBoostpackCard, {
          id: boostpack.id,
          key: boostpack.id,
          boostpack: boostpack,
          "data-os-anchor": 'boostpackCard'+boostpack.id,
          class: "z-10",
          "data-aos": "zoom-in-up"
        }, null, 8, ["id", "boostpack", "data-os-anchor"]))
      }), 128)),
      _createVNode(_component_default_media_net_ad)
    ], 512), [
      [_vShow, !_ctx.isBoostpackFeedLoading()]
    ])
  ]))
})